/**
 * src/admin-ui/src/utils/auth.ts
 *
 * Build API request headers from the in-memory Keycloak session.
 */
import { getValidAccessToken } from './keycloak';

export const getAuthHeaders = async (): Promise<Record<string, string>> => {
  const token = await getValidAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getAuthHeadersWithContentType = async (): Promise<Record<string, string>> => ({
  ...(await getAuthHeaders()),
  'Content-Type': 'application/json',
});
